import api from '../../interceptorServices';
import base_url,{onsite_url} from '../../../config';
const path = onsite_url+'api/onsite/presentationSetup';
const countriesUrl = base_url+'api/admin/esCountries';
const paymentReceiptUrl = base_url+'api/event/paymentReceipt';
const participantTypePath = base_url+'api/admin/participantType';


export const getData = async () => {
  const response = await api.get(path);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};

export const getcountries = async () => {
    const response = await api.get(countriesUrl);
    return response.data;
};


export const getPaymentReceiptData = async (params) => {
  const whereParam = params;
  const response = await api.post(paymentReceiptUrl, whereParam);
  return response.data.data;
};


export const getParticipantTypeData = async () => {
  const response = await api.get(participantTypePath);
  return response.data;
};
export const getPresentationByParticipantName = async (req) => {
  const participant_name = req.participant_name
  const day = req.day
  const category = req.category
  
  const response = await api.get(path,{params: {
    participant_name: participant_name,   
    day: day,   
    category: category,   
  }},);
    return response.data;   
}
